var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"app-helper-button opacity-0 focus:outline-none transition duration-300 ease-in-out"},[_c('feather',{staticClass:"text-blue ml-2 cursor-pointer",attrs:{"size":"16","type":"info"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }